export enum EPriority {
  MINOR = 'Baixa prioridade',
  DEFAULT = 'Média prioridade',
  MAXIMUM = 'Alta prioridade',
}
